import { Plus, Upload } from 'lucide-react'
import { Button } from '../shadcn/button'
import { Card, CardContent } from '../shadcn/card'

export interface EmptyStateProps {
  anoBase: number
  onNew?: () => void
  onImport?: () => void
}

export function EmptyState({ anoBase, onNew, onImport }: EmptyStateProps) {
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center justify-center px-6 py-20 text-center">
        <div className="bg-primary text-primary-foreground flex h-14 w-14 items-center justify-center rounded-full font-display text-3xl">
          §
        </div>
        <h2 className="mt-6 font-display text-2xl tracking-tight">
          Nenhum lançamento em {anoBase}
        </h2>
        <p className="text-muted-foreground mt-2 max-w-md text-sm leading-relaxed">
          Adicione seu primeiro rendimento ou imposto pago no exterior — o cálculo segue
          automaticamente a IN&nbsp;SRF&nbsp;208/2002.
        </p>
        <div className="mt-8 flex items-center gap-3">
          <Button onClick={onNew}>
            <Plus />
            Novo lançamento
          </Button>
          <Button variant="outline" onClick={onImport}>
            <Upload />
            Importar arquivo
          </Button>
        </div>
        <p className="text-muted-foreground mt-6 text-[11px]">
          Atalhos: <kbd className="border-border bg-muted rounded border px-1.5 py-0.5 font-mono text-[10px]">N</kbd>{' '}
          novo · <kbd className="border-border bg-muted rounded border px-1.5 py-0.5 font-mono text-[10px]">I</kbd>{' '}
          importar · <kbd className="border-border bg-muted rounded border px-1.5 py-0.5 font-mono text-[10px]">?</kbd>{' '}
          ajuda
        </p>
      </CardContent>
    </Card>
  )
}
